import * as React from "react";
import Link from "next/link";
import { fetchFAQ, IArticle } from "@nju/data-access-portal-help";
import { portalRoutes, salesRoutes } from "@nju/routes";
import { IScope } from "@nju/scope";
import { A, Separator } from "@nju/ui";
import { Summary } from "./Summary";

type IStates = "IDLE" | "LOADING" | "ERROR" | "DONE";

interface IProps {
  variant?: IScope;
}

export function ErrorPage({ variant = "portal" }: IProps) {
  const [currentState, setCurrentState] = React.useState<IStates>("IDLE");
  const [article, setArticle] = React.useState<IArticle | undefined>();
  const isLoading = currentState === "IDLE" || currentState === "LOADING";
  const articleId =
    "dlaczego-usługa-nju-światłowód-nie-jest-dostępna-w-mojej-lokalizacji?";

  React.useEffect(() => {
    setCurrentState("LOADING");

    fetchFAQ({ categoryId: "oferta-nju" }).then((result) => {
      if (result.isOk) {
        setArticle(
          result.value[0].articles.find((article) => {
            return article.articleId === articleId;
          }),
        );

        return setCurrentState("DONE");
      }
      return setCurrentState("ERROR");
    });
  }, []);

  return (
    <Summary
      article={article}
      isLoading={isLoading}
      isOk={false}
      variant={variant}
    >
      <>
        <Separator size="xl" />
        <div className="flex justify-between only-mobile:flex-col-reverse from-tablet:flex-row">
          <Link
            href={
              variant !== "sales"
                ? portalRoutes.swiatlowod.get()
                : salesRoutes.panel.get()
            }
            passHref={true}
          >
            <A
              className="only-mobile:mt-3"
              data-cy="back-to-landing-page-button"
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
              variant="secondary"
            >
              wróć do strony głównej
            </A>
          </Link>
          <Link
            href={portalRoutes.sprawdzDostepnosc.index.get()}
            passHref={true}
          >
            <A
              data-cy="check-another-address-button"
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
            >
              sprawdź inny adres
            </A>
          </Link>
        </div>
      </>
    </Summary>
  );
}
